import { typedQueryClient, useTypedQuery } from "hooks";
import { ShareboxDashboardQueryKeys } from "modules/ShareboxDashboard/queryKeys";

export const useShareboxFilters = () => useTypedQuery({ queryKey: ShareboxDashboardQueryKeys.filters, initialData: 1 });

export const setShareboxFilters = (newPage: number) => typedQueryClient.setQueryData(ShareboxDashboardQueryKeys.filters, newPage);
